// src/App.js
import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import RepDashboard from './pages/RepDashboard';
import Orders from './pages/Orders';
import Reps from './pages/Reps';
import BulkReps from './pages/BulkReps';
import Payroll from './pages/Payroll';
import CompPlans from './pages/CompPlans';
import ImportPage from './pages/Import';
import MissingAgent from './pages/MissingAgent';
import StackRanking from './pages/StackRanking';
import YTDCommissions from './pages/YTDCommissions';
import NonUsage from './pages/NonUsage';
import BucketRelease from './pages/BucketRelease';
import AlertsPage from './pages/Alerts';
import ClaimOrder from './pages/ClaimOrder';
import Chargebacks from './pages/Chargebacks';
import CompPlanSeeder from './pages/CompPlanSeeder';
import RosterImport from './pages/RosterImport';

function PrivateRoute({ children }) {
  const { currentUser } = useAuth();
  return currentUser ? children : <Navigate to="/login" />;
}

function AdminRoute({ children }) {
  const { userProfile } = useAuth();
  return userProfile?.role === 'admin' ? children : <Navigate to="/dashboard" />;
}

function SmartDashboard() {
  const { userProfile } = useAuth();
  return userProfile?.role === 'admin' ? <Dashboard /> : <RepDashboard />;
}

function AppRoutes() {
  const { currentUser } = useAuth();
  return (
    <Routes>
      <Route path="/login" element={currentUser ? <Navigate to="/dashboard" /> : <Login />} />
      <Route path="/" element={<Navigate to="/dashboard" />} />
      <Route path="/dashboard" element={<PrivateRoute><Layout><SmartDashboard /></Layout></PrivateRoute>} />
      <Route path="/orders" element={<PrivateRoute><AdminRoute><Layout><Orders /></Layout></AdminRoute></PrivateRoute>} />
      <Route path="/reps" element={<PrivateRoute><AdminRoute><Layout><Reps /></Layout></AdminRoute></PrivateRoute>} />
      <Route path="/bulk-reps" element={<PrivateRoute><AdminRoute><Layout><BulkReps /></Layout></AdminRoute></PrivateRoute>} />
      <Route path="/payroll" element={<PrivateRoute><AdminRoute><Layout><Payroll /></Layout></AdminRoute></PrivateRoute>} />
      <Route path="/comp-plans" element={<PrivateRoute><AdminRoute><Layout><CompPlans /></Layout></AdminRoute></PrivateRoute>} />
      <Route path="/import" element={<PrivateRoute><AdminRoute><Layout><ImportPage /></Layout></AdminRoute></PrivateRoute>} />
      <Route path="/missing-agent" element={<PrivateRoute><AdminRoute><Layout><MissingAgent /></Layout></AdminRoute></PrivateRoute>} />
      <Route path="/stack-ranking" element={<PrivateRoute><AdminRoute><Layout><StackRanking /></Layout></AdminRoute></PrivateRoute>} />
      <Route path="/ytd-commissions" element={<PrivateRoute><AdminRoute><Layout><YTDCommissions /></Layout></AdminRoute></PrivateRoute>} />
      <Route path="/non-usage" element={<PrivateRoute><AdminRoute><Layout><NonUsage /></Layout></AdminRoute></PrivateRoute>} />
      <Route path="/bucket-release" element={<PrivateRoute><AdminRoute><Layout><BucketRelease /></Layout></AdminRoute></PrivateRoute>} />
      <Route path="/alerts" element={<PrivateRoute><AdminRoute><Layout><AlertsPage /></Layout></AdminRoute></PrivateRoute>} />
      <Route path="/claim-order" element={<PrivateRoute><Layout><ClaimOrder /></Layout></PrivateRoute>} />
      <Route path="/chargebacks" element={<PrivateRoute><Layout><Chargebacks /></Layout></PrivateRoute>} />
      <Route path="/seed-comp-plans" element={<PrivateRoute><AdminRoute><Layout><CompPlanSeeder /></Layout></AdminRoute></PrivateRoute>} />
      <Route path="/roster-import" element={<PrivateRoute><AdminRoute><Layout><RosterImport /></Layout></AdminRoute></PrivateRoute>} />
      <Route path="/my-orders" element={<PrivateRoute><Layout><Orders /></Layout></PrivateRoute>} />
      <Route path="/my-pay" element={<PrivateRoute><Layout><Payroll /></Layout></PrivateRoute>} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  );
}
